import { useState } from "react";
import { Col, Form, Input } from "reactstrap";
import { Btn, H4, H5, Image } from "../../../../AbstractElements";
import { Call, Href, OtpCode, OtpCodeSent, Resend, VerificationCodeHeading, Verify } from "../../../../Constant";
import { dynamicImage } from "../../../../Service/DynamicImage";

const VerificationCode = () => {
  const numbersData: number[] = [1, 2, 3, 4, 5, 6];
  const [val, setVal] = useState(Array(6).fill(undefined));

  const handleChange = (e: string, index: number) => {
    if (e.length > 1) return;
    else {
      const tempt = [...val];
      tempt[index] = parseInt(e);
      setVal(tempt);
    }
  };

  return (
    <Col md="6">
      <div className="card-wrapper border rounded-3 h-100">
        <div className="authenticate">
          <H4>{VerificationCodeHeading}</H4>
          <Image className="img-fluid" src={dynamicImage("forms/authenticate.png")} alt="authenticate" />
          <span>{OtpCodeSent}</span>
          <span>+91********70</span>
          <Form className="row" onSubmit={(event) => event.preventDefault()}>
            <Col>
              <H5>{OtpCode}</H5>
            </Col>
            <Col className="otp-generate">
              {numbersData.map((data, index) => (
                <Input key={data} value={val[index]} className="code-input" type="number" onChange={(e) => handleChange(e.target.value, index)} />
              ))}
            </Col>
            <Col>
              <Btn color="primary" className="w-100">{Verify}</Btn>
            </Col>
            <div>
              <span>Not received your code?</span>
              <span><a href={Href}>{Resend} </a>OR<a href={Href}>{Call}</a></span>
            </div>
          </Form>
        </div>
      </div>
    </Col>
  );
};

export default VerificationCode;
